<ion-row class="payment-dashboard-row">
  <ion-col size="2" data-cy="ar-aging-row-customer-information">
    <div>
      <p data-cy="ar-aging-row-customer-name">
        {{ customerMetrics.customerName | titlecase }}
      </p>
      <a data-cy="ar-aging-row-customer-number" (click)="goToAllInvoices()">
        #{{ customerMetrics.customerNumber }}
      </a>
    </div>
  </ion-col>

  <ion-col size="1.5" data-cy="ar-aging-row-current-percentage">
    <p class="padding-left">{{ customerMetrics.currentPercentage }}%</p>
  </ion-col>

  <ion-col
    [size]="isShrink ? '1.6' : '2.4'"
    data-cy="ar-aging-row-unused-credits
    "
  >
    <p class="term" (click)="onClickTerm(!isShrink)">
      {{ truncatedTerm }}
      <ion-icon
        *ngIf="isShrink"
        data-cy="chevron-expand"
        name="chevron-forward-outline"
      ></ion-icon>

      <ion-icon
        class="chevron-shrink"
        data-cy="chevron-shrink"
        *ngIf="!isShrink"
        name="chevron-back-outline"
      ></ion-icon>
    </p>
  </ion-col>

  <ion-col
    [size]="isShrink ? '1.6' : '1.4'"
    data-cy="ar-aging-row-one-seven-days"
  >
    <p class="padding-left">
      {{ customerMetrics.oneSevenDays | currency }}
    </p>
  </ion-col>

  <ion-col
    [size]="isShrink ? '1.6' : '1.4'"
    data-cy="ar-aging-row-eight-fifteen-days"
  >
    <p class="padding-left">
      {{ customerMetrics.eightFifteenDays | currency }}
    </p>
  </ion-col>

  <ion-col
    [size]="isShrink ? '1.6' : '1.4'"
    data-cy="ar-aging-row-sixteen-thirty-days"
  >
    <p class="padding-left">
      {{ customerMetrics.sixteenThirtyDays | currency }}
    </p>
  </ion-col>

  <ion-col [size]="isShrink ? '1.6' : '1.4'" data-cy="ar-aging-row-thirty-plus">
    <p class="padding-left">
      {{ customerMetrics.thirtyPlus | currency }}
    </p>
  </ion-col>

  <ion-col data-cy="chevron-next" (click)="goToAllInvoices()">
    <ion-icon name="chevron-forward-outline"></ion-icon>
  </ion-col>
</ion-row>
